// extracted by mini-css-extract-plugin
var _1 = "PostVerifyFooter-module__animateUploadProgressBarWidth--z0z3o";
var _2 = "PostVerifyFooter-module__animatedBackground--s31_m";
var _3 = "PostVerifyFooter-module__ctaContainer--kRDrL";
var _4 = "PostVerifyFooter-module__label--rc5nF";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "ctaContainer", _4 as "label" }
